// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1B-sZ","head":"ProcedureTableInfo_head__3TWP4"};